export const NotificationMap = {

    FETCH_NOTIFICATION_START: 'FETCH_NOTIFICATION_START',
    FETCH_NOTIFICATION_SUCCESS: 'FETCH_NOTIFICATION_SUCCESS',
    FETCH_NOTIFICATION_ERROR: 'FETCH_NOTIFICATION_ERROR', 

    UPDATE_NOTIFICATION_STATUS_START: 'UPDATE_NOTIFICATION_STATUS_START',
    UPDATE_NOTIFICATION_STATUS_SUCCESS: 'UPDATE_NOTIFICATION_STATUS_SUCCESS',
    UPDATE_NOTIFICATION_STATUS_ERROR: 'UPDATE_NOTIFICATION_STATUS_ERROR',

    FETCH_LATEST_NOTIFICATION_START: 'FETCH_LATEST_NOTIFICATION_START',
    FETCH_LATEST_NOTIFICATION_SUCCESS: 'FETCH_LATEST_NOTIFICATION_SUCCESS',
    FETCH_LATEST_NOTIFICATION_FAIL: 'FETCH_LATEST_NOTIFICATION_FAIL',
    NOTIFICATION_BATCH_NUMBER: 'NOTIFICATION_BATCH_NUMBER'

}

export const NotificationAction = {

    fetchNotificationStart: () => ({type: NotificationMap.FETCH_NOTIFICATION_START}),
    fetchNotificationSuccess: (data) => ({type: NotificationMap.FETCH_NOTIFICATION_SUCCESS, payload: data}),
    fetchNotificationError: () => ({type: NotificationMap.FETCH_NOTIFICATION_ERROR}),

    updateNotificationStatusStart: (data) => ({type: NotificationMap.UPDATE_NOTIFICATION_STATUS_START, payload: data}),
    updateNotificationStatusSuccess: (data) => ({type: NotificationMap.UPDATE_NOTIFICATION_STATUS_SUCCESS, payload: data}), 
    updateNotificationStatusError: () => ({type:NotificationMap.UPDATE_NOTIFICATION_STATUS_ERROR}),

    setNotificationBatchNumber: (data) => ({type: NotificationMap.NOTIFICATION_BATCH_NUMBER, payload: data}),

}
